const Circle = () => {
	return <div class="circle"></div>;
};

export default Circle;
